/*
--------------------------------------------------------

 About PIGMENT Lab

--------------------------------------------------------
*/

var GMap = {

    map : ""
    ,init : function(zoom_no){
        // 座標
        var latlng = new google.maps.LatLng(35.621335, 139.749666);
        // オプション（ズームレベル、コントロール表示）
        var mapOptions = {
            center: latlng,
            zoom: zoom_no,
            scrollwheel: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false,
            panControl: false
        };
        //　地図オブジェクト
        map = new google.maps.Map(document.getElementById("gmap"), mapOptions);

        //　マーカー
        var markerLatlng = new google.maps.LatLng(35.621335, 139.749666);
        var marker = new google.maps.Marker({
            position: markerLatlng,
            map: map,
            icon: 'https://cdn.shopify.com/s/files/1/0580/5926/0089/files/ico_marker.png'
        });
        google.maps.event.addListener(marker, 'click', function(){
            window.open("https://goo.gl/maps/4LNM2kXbKEw", '_blank');
        });

        // 地図のスタイル
        var styleOptions = [
            {
                featureType: 'all',
                stylers: [
                    { saturation : -90 },
                    { gamma : 1 },
                    { hue : '#c3cccd'},
                    { lightness : 13}
                ]
            }
        ];
        
        var customType = new google.maps.StyledMapType(styleOptions);
        map.mapTypes.set('myset', customType);
        map.setMapTypeId('myset');
    }

};
$(function(){

    $(window).on('load', function(e) {
        var ww = $(window).width();
        var zoom_no = 16;
        if(ww <= 768){
            zoom_no = 15;
        }
        GMap.init(zoom_no);
    });

    // カバー写真
    $('#coverItems_slider').slick({
        slidesToShow: 1,
        infinite: true,
        fade: true,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 1500,
        pauseOnHover: false,
        pauseOnFocus: false,
        speed: 1000
    });

    // Pigment Lab images
    $('#labo_slider').slick({
        slidesToShow: 1,
        infinite: true,
        dots: true,
        autoplay: false
    });

    // リサイズ時の設定
    $(window).on('resize', function(){
        var ww = $(window).width();
        if(ww <= 768){
            var imgH = $('.labo_slider_item_img').height();
            $('#labo_slider .slick-prev,#labo_slider .slick-next').css('top', imgH/2-13);
        }else{
            $('#labo_slider .slick-prev,#labo_slider .slick-next').css('top', '250px');
        }
    });
    setTimeout(function(){
        $(window).trigger('resize');
    }, 50);

});
